var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-banner"},[_c('div',{staticClass:"top"}),(
      _vm.extras.banner.display == 1 &&
      _vm.extras.banner.src &&
      _vm.extras.kvlink &&
      _vm.extras.kvlink.display == 1
    )?_c('a',{attrs:{"href":_vm.extras.kvlink.model}},[_c('div',{staticClass:"banner",style:({
        backgroundImage:
          'url(' +
          (_vm.extras.banner.display === 1
            ? _vm.extras.banner.src
              ? _vm.extras.banner.src
              : _vm.imgUrlObj.wap.banner
            : '') +
          ')',
        backgroundColor:
          _vm.extras.bannerBackgroundColor && _vm.extras.bannerBackgroundColor
            ? _vm.extras.bannerBackgroundColor.color
            : '',
        backgroundSize: '100% auto',
      })},[_c('div',{staticClass:"title",style:({
          display:
            _vm.extras.titlefont && _vm.extras.titlefont.display == 1 ? '' : 'none',
          color: _vm.extras.titlefont.color ? _vm.extras.titlefont.color : '',
        }),domProps:{"innerHTML":_vm._s(_vm.seminarInfo.title)}}),(_vm.seminarInfo.startTime && _vm.extras.meetingTime.display == 1)?_c('div',{staticClass:"time2",style:({
          color: _vm.extras.meetingTime.color ? _vm.extras.meetingTime.color : '',
          backgroundColor: _vm.extras.meetingTime.bg ? _vm.extras.meetingTime.bg : '',
        })},[_vm._v(" "+_vm._s(_vm.handleTimeStamps(_vm.seminarInfo.startTime, _vm.seminarInfo.endTime))+" ")]):_vm._e(),(_vm.seminarInfo.address)?_c('div',{staticClass:"time2",style:({
          display:
            _vm.extras.meetingAddress && _vm.extras.meetingAddress.display == 1
              ? 'block'
              : 'none',
          color: _vm.extras.meetingAddress && _vm.extras.meetingAddress.color,
          backgroundColor: _vm.extras.meetingAddress.bg
            ? _vm.extras.meetingAddress.bg
            : '',
        })},[_vm._v(" "+_vm._s(_vm.seminarInfo.address)+" ")]):_vm._e(),_c('div',{staticClass:"remainder",style:({
          display:
            _vm.extras.meetingCountDown && _vm.extras.meetingCountDown.display == 1
              ? 'block'
              : 'none',
          color: _vm.extras.meetingCountDown && _vm.extras.meetingCountDown.color,
          backgroundColor: _vm.extras.meetingCountDown.bg
            ? _vm.extras.meetingCountDown.bg
            : '',
        })},[(_vm.seminarStatus === 3)?_c('span',[_vm._v("进行中")]):_vm._e(),(_vm.seminarStatus === 4)?_c('span',[_vm._v("已结束")]):_vm._e(),(_vm.seminarStatus === 1)?_c('span',[_vm._v("距离会议开始"),_c('span',{staticClass:"remainder-num",style:({
              color:
                _vm.extras.meetingCountDownNum &&
                _vm.extras.meetingCountDownNum.color,
            })},[_vm._v(_vm._s(_vm.remainder.days))]),_vm._v("天"),_c('span',{staticClass:"remainder-num",style:({
              color:
                _vm.extras.meetingCountDownNum &&
                _vm.extras.meetingCountDownNum.color,
            })},[_vm._v(_vm._s(_vm.remainder.hours))]),_vm._v("时"),_c('span',{staticClass:"remainder-num",style:({
              color:
                _vm.extras.meetingCountDownNum &&
                _vm.extras.meetingCountDownNum.color,
            })},[_vm._v(_vm._s(_vm.remainder.minutes))]),_vm._v("分")]):_vm._e()]),(
          !_vm.isFrozen &&
          _vm.seminarStatus !== 4 &&
          (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
          (_vm.isSetting == 1 ||
            (_vm.isSetting == 0 &&
              _vm.memberInfo.signUpStatus == 0 &&
              !_vm.isLogin &&
              _vm.seminarInfo.isOpenMember != 0 &&
              _vm.signUpUrl) ||
            (_vm.isSetting == 0 &&
              _vm.memberInfo.signUpStatus == 0 &&
              (_vm.isLogin || _vm.seminarInfo.isOpenMember == 0) &&
              _vm.signUpUrl)) &&
          _vm.extraItem.extras('noSignUp.display', 1)
        )?_c('div',{staticClass:"seminar-btn"},[(_vm.isSetting == 1)?_c('div',{staticClass:"btn",style:({
            backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
          })},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.isSetting == 0 &&
            _vm.memberInfo.signUpStatus == 0 &&
            !_vm.isLogin &&
            _vm.seminarInfo.isOpenMember != 0 &&
            _vm.signUpUrl
          ),expression:"\n            isSetting == 0 &&\n            memberInfo.signUpStatus == 0 &&\n            !isLogin &&\n            seminarInfo.isOpenMember != 0 &&\n            signUpUrl\n          "}],staticClass:"btn",style:({
            backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
          }),on:{"click":function($event){return _vm.goto('login')}}},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]),(
            _vm.isSetting == 0 &&
            _vm.memberInfo.signUpStatus == 0 &&
            (_vm.isLogin || _vm.seminarInfo.isOpenMember == 0) &&
            _vm.signUpUrl
          )?_c('div',{staticClass:"btn",style:({
            backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
          }),on:{"click":function($event){return _vm.goto('newLogin')}}},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]):_vm._e()]):_vm._e(),(
          !_vm.isFrozen &&
          _vm.seminarStatus !== 4 &&
          (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
          _vm.isSetting == 0 &&
          _vm.memberInfo.signUpStatus == 1 &&
          _vm.extraItem.extras('checkPending.display', 1)
        )?_c('div',{staticClass:"seminar-btn"},[_c('div',{staticClass:"btn audit",style:({
            backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
          }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.checkPending.model || "审核中...")+" ")])]):_vm._e(),(
          !_vm.isFrozen &&
          _vm.seminarStatus !== 4 &&
          (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
          _vm.isSetting == 0 &&
          (_vm.memberInfo.signUpStatus == 2 || _vm.memberInfo.signUpStatus == 3)
        )?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraItem.extras('approve.display', 1)),expression:"extraItem.extras('approve.display', 1)"}],staticClass:"seminar-btn"},[_c('div',{staticClass:"btn registered",style:({
            backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
          }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.approve.model || "报名成功")+" ")])]):_vm._e(),(
          !_vm.isFrozen &&
          _vm.seminarStatus !== 4 &&
          (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
          _vm.isSetting == 0 &&
          _vm.memberInfo.signUpStatus == 4 &&
          _vm.extraItem.extras('reject.display', 1)
        )?_c('div',{staticClass:"seminar-btn"},[_c('div',{staticClass:"btn refuse",style:({
            backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
          }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.reject.model || "拒绝报名")+" ")])]):_vm._e()])]):_vm._e(),(_vm.extras.kvlink == undefined || _vm.extras.kvlink.display == 0)?_c('div',{staticClass:"banner",style:({
      backgroundImage:
        'url(' +
        (_vm.extras.banner.display === 1
          ? _vm.extras.banner.src
            ? _vm.extras.banner.src
            : _vm.imgUrlObj.wap.banner
          : '') +
        ')',
      backgroundColor:
        _vm.extras.bannerBackgroundColor && _vm.extras.bannerBackgroundColor
          ? _vm.extras.bannerBackgroundColor.color
          : '',
      backgroundSize: '100% auto',
    })},[_c('div',{staticClass:"title",style:({
        display:
          _vm.extras.titlefont && _vm.extras.titlefont.display == 1 ? '' : 'none',
        color: _vm.extras.titlefont.color ? _vm.extras.titlefont.color : '',
      }),domProps:{"innerHTML":_vm._s(_vm.seminarInfo.title)}}),(_vm.seminarInfo.startTime && _vm.extras.meetingTime.display == 1)?_c('div',{staticClass:"time2",style:({
        color: _vm.extras.meetingTime.color ? _vm.extras.meetingTime.color : '',
        backgroundColor: _vm.extras.meetingTime.bg ? _vm.extras.meetingTime.bg : '',
      })},[_vm._v(" "+_vm._s(_vm.handleTimeStamps(_vm.seminarInfo.startTime, _vm.seminarInfo.endTime))+" ")]):_vm._e(),(_vm.seminarInfo.address)?_c('div',{staticClass:"time2",style:({
        display:
          _vm.extras.meetingAddress && _vm.extras.meetingAddress.display == 1
            ? 'block'
            : 'none',
        color: _vm.extras.meetingAddress && _vm.extras.meetingAddress.color,
        backgroundColor: _vm.extras.meetingAddress.bg
          ? _vm.extras.meetingAddress.bg
          : '',
      })},[_vm._v(" "+_vm._s(_vm.seminarInfo.address)+" ")]):_vm._e(),_c('div',{staticClass:"remainder",style:({
        display:
          _vm.extras.meetingCountDown && _vm.extras.meetingCountDown.display == 1
            ? 'block'
            : 'none',
        color: _vm.extras.meetingCountDown && _vm.extras.meetingCountDown.color,
        backgroundColor: _vm.extras.meetingCountDown.bg
          ? _vm.extras.meetingCountDown.bg
          : '',
      })},[(_vm.seminarStatus === 3)?_c('span',[_vm._v("进行中")]):_vm._e(),(_vm.seminarStatus === 4)?_c('span',[_vm._v("已结束")]):_vm._e(),(_vm.seminarStatus === 1)?_c('span',[_vm._v("距离会议开始"),_c('span',{staticClass:"remainder-num",style:({
            color:
              _vm.extras.meetingCountDownNum && _vm.extras.meetingCountDownNum.color,
          })},[_vm._v(_vm._s(_vm.remainder.days))]),_vm._v("天"),_c('span',{staticClass:"remainder-num",style:({
            color:
              _vm.extras.meetingCountDownNum && _vm.extras.meetingCountDownNum.color,
          })},[_vm._v(_vm._s(_vm.remainder.hours))]),_vm._v("时"),_c('span',{staticClass:"remainder-num",style:({
            color:
              _vm.extras.meetingCountDownNum && _vm.extras.meetingCountDownNum.color,
          })},[_vm._v(_vm._s(_vm.remainder.minutes))]),_vm._v("分")]):_vm._e()]),(
        !_vm.isFrozen &&
        _vm.seminarStatus !== 4 &&
        (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
        (_vm.isSetting == 1 ||
          (_vm.isSetting == 0 &&
            _vm.memberInfo.signUpStatus == 0 &&
            !_vm.isLogin &&
            _vm.seminarInfo.isOpenMember != 0 &&
            _vm.signUpUrl) ||
          (_vm.isSetting == 0 &&
            _vm.memberInfo.signUpStatus == 0 &&
            (_vm.isLogin || _vm.seminarInfo.isOpenMember == 0) &&
            _vm.signUpUrl)) &&
        _vm.extraItem.extras('noSignUp.display', 1)
      )?_c('div',{staticClass:"seminar-btn"},[(_vm.isSetting == 1)?_c('div',{staticClass:"btn",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        })},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
          _vm.isSetting == 0 &&
          _vm.memberInfo.signUpStatus == 0 &&
          !_vm.isLogin &&
          _vm.seminarInfo.isOpenMember != 0 &&
          _vm.signUpUrl
        ),expression:"\n          isSetting == 0 &&\n          memberInfo.signUpStatus == 0 &&\n          !isLogin &&\n          seminarInfo.isOpenMember != 0 &&\n          signUpUrl\n        "}],staticClass:"btn",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('login')}}},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]),(
          _vm.isSetting == 0 &&
          _vm.memberInfo.signUpStatus == 0 &&
          (_vm.isLogin || _vm.seminarInfo.isOpenMember == 0) &&
          _vm.signUpUrl
        )?_c('div',{staticClass:"btn",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.noSignUp.model || "立即报名")+" ")]):_vm._e()]):_vm._e(),(
        !_vm.isFrozen &&
        _vm.seminarStatus !== 4 &&
        (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
        _vm.isSetting == 0 &&
        _vm.memberInfo.signUpStatus == 1 &&
        _vm.extraItem.extras('checkPending.display', 1)
      )?_c('div',{staticClass:"seminar-btn"},[_c('div',{staticClass:"btn audit",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.checkPending.model || "审核中...")+" ")])]):_vm._e(),(
        !_vm.isFrozen &&
        _vm.seminarStatus !== 4 &&
        (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
        _vm.isSetting == 0 &&
        (_vm.memberInfo.signUpStatus == 2 || _vm.memberInfo.signUpStatus == 3)
      )?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraItem.extras('approve.display', 1)),expression:"extraItem.extras('approve.display', 1)"}],staticClass:"seminar-btn"},[_c('div',{staticClass:"btn registered",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.approve.model || "报名成功")+" ")])]):_vm._e(),(
        !_vm.isFrozen &&
        _vm.seminarStatus !== 4 &&
        (_vm.signUpUrl || _vm.memberInfo.signUpStatus != 0) &&
        _vm.isSetting == 0 &&
        _vm.memberInfo.signUpStatus == 4 &&
        _vm.extraItem.extras('reject.display', 1)
      )?_c('div',{staticClass:"seminar-btn"},[_c('div',{staticClass:"btn refuse",style:({
          backgroundColor: _vm.extras.signUpBg && _vm.extras.signUpBg.color,
        }),on:{"click":function($event){return _vm.goto('signUp')}}},[_vm._v(" "+_vm._s(_vm.extras.reject.model || "拒绝报名")+" ")])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }